/**
 * Certificate Metadata Configuration
 * 
 * Add details for each certificate here.
 * The certificate number should match the image filename.
 * 
 * Example: Certificate_1.jpg corresponds to certificate with id: 1
 */

const certificateMetadata = {
    1: {
        title: 'Unmanned Aircraft Systems & Applications Bootcamp',
        issuer: 'C-DAC Noida & JIIT',
        date: 'September 2024',
        description: '5-day intensive bootcamp on Unmanned Aircraft Systems (UAS/Drone Technology) and its applications, organized by Centre for Development of Advanced Computing, Noida in collaboration with JIIT, Noida.',
        credentialUrl: '#',
        skills: ['UAS', 'Drone Technology', 'Unmanned Aircraft', 'Aerospace', 'C-DAC']
    },
    2: {
        title: 'Flutter & Dart - The Complete Guide [2025 Edition]',
        issuer: 'Udemy',
        date: 'July 2025',
        description: 'Comprehensive 30-hour Flutter and Dart development course by Academind. Covers cross-platform mobile app development from fundamentals to advanced concepts.',
        credentialUrl: 'https://ude.my/UC-0b2eacbd-a380-4a38-85ce-6c6b7c4a8c4e',
        skills: ['Flutter', 'Dart', 'Mobile Development', 'Cross-Platform', 'App Development']
    },
    3: {
        title: 'Keploy API Fellowship Program',
        issuer: 'Keploy',
        date: '2024',
        description: 'Certificate of participation in Keploy API Fellowship Program, focused on API testing and development. Recognized by Neha Gupta, CEO of Keploy.io.',
        credentialUrl: '#',
        skills: ['API Development', 'API Testing', 'Keploy', 'Software Testing', 'Backend Development']
    }
    // Add more certificates as Certificate_4, Certificate_5, etc.
};

export default certificateMetadata;
